import styled from 'styled-components'
import Slider from 'react-slick'
import 'slick-carousel/slick/slick.css'
import 'slick-carousel/slick/slick-theme.css'
import slide2Img from '../../../assets/slide2.png'
import previousArrowImg from '../../../assets/previous-arrow.png'
import nextArrowImg from '../../../assets/next-arrow.png'
import { useCallback, useRef, useEffect, useState } from 'react'
import { chunk } from '../../../utils/util'

function Page5PcContents(prop) {
  var settings = {
    dots: false,
    infinite: true,
    speed: 400,
    autoplay: false,
    slidesToShow: 1,
    slidesToScroll: 1,
  }
  const slickRef = useRef(null)
  const previous = useCallback(() => slickRef.current.slickPrev(), [])
  const next = useCallback(() => slickRef.current.slickNext(), [])

  const selectedGoods = prop.selectedGoods
  const downListener = prop.downListener
  const moveListener = prop.moveListener
  const upListener = prop.upListener

  const [itemList, setItemList] = useState([])
  const [selectedItem, setSelectedItem] = useState({})
  const [fileList, setFileList] = useState([])

  useEffect(() => {
    setItemList(chunk(selectedGoods.itemDtoList, 4))
    setSelectedItem(selectedGoods.itemDtoList[0])
  }, [selectedGoods])

  useEffect(() => {
    setFileList(selectedItem?.fileDtoList)
    
    setTimeout(()=>{ slickRef.current?.slickGoTo(0, true);}, 100);
  }, [selectedItem])

  

  return (
    <>
      <CustomSlider {...settings} ref={slickRef}>
        {fileList &&
          fileList.map((file, idx) => {
            if (file.fileType == 'IMAGE') {
              return (
                <Slide key={file.fileSeq ?? idx}>
                  <SlideImg
                    src={process.env.REACT_APP_BASE_RESOURCES_API + file.filePath}
                    onMouseUp={() => upListener(process.env.REACT_APP_BASE_RESOURCES_API + file.filePath, idx)}
                    onMouseMove={moveListener}
                    onMouseDown={downListener}

                  />
                  <SlideText  dangerouslySetInnerHTML={ {__html: file.fileInfo} }/>
                </Slide>
              )
            }else{
              return (
                <SlideV
                  key={file.fileSeq ?? idx}
                  onMouseUp={() => upListener('video',idx)}
                  onMouseMove={moveListener}
                  onMouseDown={downListener}
                >
                  <SlideVideo
                    controls
                    id={'video'+idx}
                    src={process.env.REACT_APP_BASE_RESOURCES_API + file.filePath}
                  />
                  <SlideText  dangerouslySetInnerHTML={ {__html: file.fileInfo} }/>
                </SlideV>
              )

            }
          })}
      </CustomSlider>
        <ArrowsContainer>
          <Previous onClick={previous}>
            <PreviousArrow src={previousArrowImg} />
          </Previous>
          <Next onClick={next}>
            <NextArrow src={nextArrowImg} />
          </Next>
        </ArrowsContainer>
      <Bottom>
        {selectedItem && selectedGoods && (
          <TextsContainer>
            <Text2>
              {selectedItem.itemKorName} | {selectedGoods.gsName}
            </Text2>
            <Text1>{selectedItem.itemEngName}</Text1>
          </TextsContainer>
        )}

        {selectedItem &&
          itemList.map((item, idx) => {
            return (
              <Row key={idx}>
                {item.map((i, idx) => {
                  return (
                    <Box
                      key={idx}
                      selected={i.itemSeq == selectedItem.itemSeq}
                      onClick={() => {
                        setSelectedItem(i)
                      }}
                    >
                      {i.itemName}
                    </Box>
                  )
                })}
              </Row>
            )
          })}
      </Bottom>
    </>
  )
}

const SlideText = styled.p`
  font-family: Noto Sans KR;
  font-weight: normal;
  font-size: 10px;
  letter-spacing: -0.5px;
  text-align: end;
  color: #ffffff;
  margin-top: -50px;
  margin-right: 10vw;
`;
const CustomSlider = styled(Slider)`
  height: 375px;
  text-align:center;
  background:black;
  overflow-y:hidden;
`
const Slide = styled.div`
  height: 375px;
  overflow-y:hidden;
`
const SlideImg = styled.img`
  width: 100%;
  height: 375px;
  object-fit: cover;
`
const SlideV = styled.div`
  height: 375px;
  overflow-y:hidden;
`
const SlideVideo = styled.video`
  height: 375px;
  object-fit: contain;
`

const ArrowsContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 375px;
  margin-top: -375px;
  z-index: 500;
  padding: 0 4px;
  pointer-events: none;
`
const Previous = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 56px;
  height: 100%;
  cursor: pointer;
  pointer-events: auto;
  -webkit-tap-highlight-color: transparent;
  tap-highlight-color: transparent;
  outline: none;
  user-select: none;
  -webkit-user-select: none;

  &:active {
    background-color: transparent;
  }
`
const Next = styled(Previous)``
const PreviousArrow = styled.img`
  width: 10px;
  height: 18.3px;
  -webkit-tap-highlight-color: transparent;
  pointer-events: none;
  user-select: none;
`
const NextArrow = styled.img`
  width: 10px;
  height: 18.3px;
  -webkit-tap-highlight-color: transparent;
  pointer-events: none;
  user-select: none;
`

const Bottom = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`
const TextsContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 5px;
  margin-top: 36.4px;
  margin-left: 19.8px;
  margin-bottom: 36.8px;
`
const Text1 = styled.p`
  font-family: GMarketSans;
  font-weight: 500;
  font-size: 25px;
  color: #2e2e2e;
  letter-spacing: 1.5px;
`
const Text2 = styled.p`
  font-family: Noto Sans KR;
  font-weight: normal;
  font-size: 18px;
  color: #b7b7b7;
  letter-spacing: -0.3px;
`
const Row = styled.div`
  width: 70vw;
  display: flex;
  justify-content: center;
  gap: 14.2px;
  margin-bottom: 100px;
`
const Box = styled.div`
  height: 46.2px;
  background: ${(props) => (props.selected ? '#a2967f' : '#fff')};
  display: flex;
  flex: 1;
  align-items: center;
  justify-content: center;
  font-size: 15px;
  font-family: Noto Sans KR;
  font-weight: normal;
  color: ${(props) => (props.selected ? '#fff' : '#808080')};
  border: ${(props) =>
    props.selected ? '0.3px solid transparent' : '0.3px solid #9D9D9D'};
  cursor: pointer;
`

export default Page5PcContents
